import { VDivider } from 'vuetify/lib/components/VDivider';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('barra-de-filtro',{staticClass:"align-center",staticStyle:{"height":"52px"},model:{value:(_vm.filtros),callback:function ($$v) {_vm.filtros=$$v},expression:"filtros"}}),_c(VDivider),_c('tabela-produtos',{attrs:{"filtros":_vm.filtros}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }